var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHomeActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m21.013 9.722-7.5-6.816a1.5 1.5 0 0 0-2.025 0l-7.5 6.816a1.5 1.5 0 0 0-.488 1.106v8.635c-.006.378.127.745.375 1.03A1.5 1.5 0 0 0 5 21h4.5a.75.75 0 0 0 .75-.75v-4.5A.75.75 0 0 1 11 15h3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 0 .75.75H20c.249.002.494-.06.712-.178A1.51 1.51 0 0 0 21.5 19.5v-8.672a1.5 1.5 0 0 0-.488-1.106"
})));
export default SvgHomeActive;